module.exports = __webpack_public_path__ + "static/media/github-logo.1d3ffee3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/github-logo.svg
// module id = 34
// module chunks = 0